import React from 'react';
import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import usePeriod from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/usePeriod';

export default function Period() {
  const {
    startDate,
    endDate,
    dateIntervals,
    changePeriod,
  } = usePeriod();
  return (
    <Accordion.Item eventKey="period" id="period-accordion">
      <Accordion.Header>Período de Análise</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={changePeriod}
          includeDateIntervals={dateIntervals}
          inline
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
